import React from 'react';
import { useTranslation } from 'react-i18next';

import { CreditCard, Plan } from 'us-web-services';
import { Button, ButtonSize, ButtonType } from '../Button';

interface Props {
  creditCard: CreditCard | undefined;
  handleNextStep(): void;
  plans: Plan[];
  selectedPlanId?: number;
  setSelectedPlanId(id: number): void;
}

export const FamilyPaywallMembership = ({ creditCard, handleNextStep, plans, selectedPlanId, setSelectedPlanId }: Props): JSX.Element => {
  const { t } = useTranslation();

  const needsPaymentInfo = (): boolean => !(creditCard && creditCard.id)

  const getCta = (): string => needsPaymentInfo() ? t('components.modals.parentPaywall.cta.selectPlan') :
      t('components.modals.parentPaywall.cta.upgrade')

  const getAdjustedPlanFee = (plan: Plan): string => {
    if (plan.masterServiceAreaDiscount) {
      return (plan.fee! - plan.masterServiceAreaDiscount).toFixed(2);
    }

    return plan.fee!.toFixed(2);
  }

  const handleChange = (plan: Plan): void => {
    if (plan.id) {
      setSelectedPlanId(plan.id);
    }
  };

  return (
    <div>
      <p className='text-lg leading-tight mt-1 mb-3'>{t('components.modals.parentPaywall.body')}</p>
      {plans.map(plan => (
        <div key={plan.id} className={`border mb-2 ${selectedPlanId === plan.id ? 'bg-sapphire-50' : 'bg-gray-50'}`}>
          <label htmlFor={`plan-${plan.id}-radio`} className='flex p-3 pb-4 mb-0 justify-between items-center cursor-pointer'>
            <div className='flex items-center'>
              <input
                id={`plan-${plan.id}-radio`}
                checked={selectedPlanId === plan.id}
                className='mr-1 cursor-pointer'
                name={`plan-${plan.id}`}
                onChange={(): void => handleChange(plan)}
                type='radio'
              />
              <div className='mx-2'>
                <p className='text-lg font-bold'>{plan.name}</p>
                <p className='text-sm font-medium'>{plan.description}</p>
              </div>
            </div>
            <div className='text-right min-w-[100px]'>
              <p className='text-lg font-bold'>${getAdjustedPlanFee(plan)}</p>
              <p className='font-light'>/ {plan.frequencyLabel}</p>
            </div>
          </label>
        </div>
      ))}
      <div className='mt-4 font-bold'>
        {t('components.modals.parentPaywall.termsAgreement')}
      </div>
      <div className='text-center space-x-4 mt-4'>
        <Button buttonSize={ButtonSize.wide} buttonType={ButtonType.primary} onClick={handleNextStep}>
          {getCta()}
        </Button>
      </div>
    </div>
  );
};
